export default "__VITE_ASSET__Q8q6MSXz__"